import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useSchedulingChartsDataContext } from './hooks/useSchedulingChartsDataContext';

export const AppointmentsBySituations = () => {
    const { chartData } = useSchedulingChartsDataContext();

    return (
        <Donut
            title={'Agentamentos por Situação'}
            subtitles={chartData?.appointmentsBySituations?.map((item) => item.description)}
            chartData={chartData?.appointmentsBySituations || []}
            colors={defaultColors.slice(0, chartData?.appointmentsBySituations?.length) || []}
        />
    );
};
